import React from 'react';
import flx from '../images/flx.png';
import { Divider, Header, Image, Segment, Table } from 'semantic-ui-react';

const FlaxPower = () => {
  return (
    <Segment raised>
      <Header as='h1' textAlign='center'>
        Flax-Power
        <Header.Subheader>
          Nature's tiny yet giant food
        </Header.Subheader>
      </Header>

      <Divider />

      <Image centered src={flx} />

      <Table textAlign='center' celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>HC Flax Power Product</Table.HeaderCell>
            <Table.HeaderCell>Other flaxseed Product</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell positive>Produced in Switzerland - certified organic raw</Table.Cell>
            <Table.Cell negative>Produced in America (or different countries)</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell positive>HC-Technology (US patent 9,931,299)</Table.Cell>
            <Table.Cell negative>Standard Processing method</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell positive>Excellent bioavailability for active food ingredients (AFI)</Table.Cell>
            <Table.Cell negative>Unremarkable bioavailability</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell positive>Contains all ingredients of the whole seed</Table.Cell>
            <Table.Cell negative>Contains ingredients in an unfavorable form for digestion</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell positive>Dissolution Index (DI): >.9 (experimentally verified)</Table.Cell>
            <Table.Cell negative>Dissolution Index (DI): >.2 - .5 (experimentally verified)</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell positive>Fresh/authentic smell/taste of flaxseed</Table.Cell>
            <Table.Cell negative>Rancid smell/taste varies depending on brand</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell positive>Processing flexibility (e.g. exposure time, drying method)</Table.Cell>
            <Table.Cell negative>Limited processing flexibility (e.g. mill type)</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell positive>No refrigeration required (shelf live: 12 months)</Table.Cell>
            <Table.Cell negative>Recommends refrigeration after opening (use within 3 months)</Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Segment>
  );
}

export default FlaxPower;


// WEBPACK FOOTER //
// ./src/components/FlaxPower.js